<template lang="pug">
  div
    Box(
      v-if="!skipShow"
    )
      Loader(v-if='loading')
      ServiceForm(v-else)
    component(
      v-else
      :is="skipComponent"
      @toggle="toggleSkip"
    )
</template>

<script>
import store from "@/store";
import Box from "@/components/ui/Box.vue";
import ServiceForm from "@/components/ServiceForm.vue";
import { mapGetters, mapMutations } from "vuex";

export default {
  data: () => ({
    loading: true
  }),
  computed: {
    ...mapGetters({
      currentItem: "stages/currentItem",
      current: "stages/current",
      skipShow: "form/skipShow",
      skipComponent: "form/skipComponent",
      activeStep: "form/activeStep"
    })
  },
  components: {
    ServiceForm,
    Box
  },
  beforeRouteEnter(to, from, next) {
    const id = store.getters["services/current"];
    const getServiceById = store.getters["services/item"];
    const service = getServiceById(id);

    if (service) {
      store.commit("form/setRoute", to.name);
      // store.commit("services/setCurrent", to.name);
      store.commit("form/setState", service.form);
      if (service.title) {
        to.meta.title = service.title;
      }
    }

    next(vm => {
      vm.serviceId = id;
    });
  },
  methods: {
    ...mapMutations("form", ["toggleSkip"])
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 600);
  }
};
</script>
